<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" data-dismiss="modal" (click)="bsModalRef.hide()">×</button>
</div>
<div class="modal-body">
    <div *ngIf="list.length">
        <div *ngFor="let item of list">{{item}}</div>
    </div>
</div>
<div class="modal-footer">
    <div class="d-md-inline-block w-100">
        <button type="button" class="btn btn-primary btn-xs float-right" (click)="close()">{{closeBtnName}}</button>
    </div>
</div>